import React from 'react';

function CheckCircleIcon({ className = '', color = '#117B53' }) {
	return (
		<svg
			className={className}
			width='32'
			height='33'
			viewBox='0 0 32 33'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_271_18510)'>
				<path d='M0 0.555542H32V32.5555H0V0.555542Z' fill='white' />
				<path
					d='M16.0001 3.22217C8.64008 3.22217 2.66675 9.1955 2.66675 16.5555C2.66675 23.9155 8.64008 29.8888 16.0001 29.8888C23.3601 29.8888 29.3334 23.9155 29.3334 16.5555C29.3334 9.1955 23.3601 3.22217 16.0001 3.22217ZM13.3334 23.2222L6.66675 16.5555L8.54675 14.6755L13.3334 19.4488L23.4534 9.32883L25.3334 11.2222L13.3334 23.2222Z'
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id='clip0_271_18510'>
					<rect
						width='32'
						height='32'
						fill='white'
						transform='translate(0 0.555542)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default CheckCircleIcon;
